import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { css } from "styled-components";

filterListStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background-color: #f0f4f3;
        padding: 15px;
        margin-bottom: 0.5rem;
    `,
};

filterListStyles.filterText = {
    variant: "h3",
    fontFamily: "LatoBold",
};
